import { __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const Mobile = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M15,4 C16.1045695,4 17,4.8954305 17,6 L17,18 C17,19.1045695 16.1045695,20 15,20 L9,20 C7.8954305,20 7,19.1045695 7,18 L7,6 C7,4.8954305 7.8954305,4 9,4 L15,4 Z M15,5 L9,5 C8.48716416,5 8.06449284,5.38604019 8.00672773,5.88337887 L8,6 L8,18 C8,18.5128358 8.38604019,18.9355072 8.88337887,18.9932723 L9,19 L15,19 C15.5128358,19 15.9355072,18.6139598 15.9932723,18.1166211 L16,18 L16,6 C16,5.48716416 15.6139598,5.06449284 15.1166211,5.00672773 L15,5 Z M13,16 L13,17 L11,17 L11,16 L13,16 Z" })));
};
Mobile.displayName = 'Mobile';
export default Mobile;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Mobile.js.map